
import React, { useEffect, useState } from "react";
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { checkAvailableFreespins } from '../utils/db-functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'


export default function FreespinsRow() {
    const user = useSelector((state) => state.user.data);
    const [games, setGames] = useState([]);
    const [campaign, setCampaign] = useState({});

    useEffect(() => {
        console.log(games)
        console.log(campaign)
        if (Object.keys(user).length > 0) {
            if (user.bonus[0]?.freespinsCampaignId) {
                checkAvailableFreespins({ freespin_id: user.bonus[0].freespinsCampaignId })
                    .then(res => {
                        if ((res?.data?.campaign?.status === 'Active' || res?.data?.campaign?.status === 'Played') && res?.data?.campaign?.is_canceled === 0 && res?.data?.campaign?.quantity_left > 0) {
                            setGames(res.data.games);
                            const quantity_left = res.data.campaign.quantity_left;
                            setCampaign({quantity_left: quantity_left})
                        }

                        if ((res?.data?.campaign?.rounds - res?.data?.campaign?.roundsPlayed > 0 )) {
                            setGames(res.data.games);
                            const quantity_left = res?.data?.campaign?.rounds - res?.data?.campaign?.roundsPlayed;
                            setCampaign({quantity_left: quantity_left})
                        }
                    });
            }
        }
    }, [user]);

    return (
        <Container fluid="lg">
            {
                games.length > 0 && games.map((game, i) => {
                    return (
                        <section className="section-margin animate__animated animate__faster animate__fadeIn" key={`freespin-${i}`}>
                            <div to={`game/${game.id}`} className="freespins-row-container">
                                <div className="freespins-row-image-wrapper" >
                                    {/* <div className="freespins-row-image-background" style={{backgroundImage: `url(${game.image})`}}></div> */}
                                    <img src={game.image} className="freespins-row-image" />
                                </div>
                                <div className="freespins-row-text-wrapper">
                                    <h2 className="subtitle-sm white-87 mb-1">
                                        You have <span className="freespins-row-text-gold">{campaign.quantity_left} free spins</span> in <span className="freespins-row-text-gold">{game.name}</span>!
                                    </h2>
                                    {/* <p className="mb-0">Play now!</p> */}
                                </div>
                                <div className="freespins-row-button-wrapper">
                                    <Link to={`game/${game.id}`} className="btn-gold">Play now</Link>
                                </div>
                            </div>
                        </section>
                    )
                })
            }
        </Container>
    )
}